import { useContextState } from "../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      width: '100%',
      height: '100%',
      padding: '30px 40px 35px 10px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      overflow: 'hidden',
    },
    containerFragments: {
      margin: 0,
      padding: '24px 0',
      boxShadow: 'none',
      flex: 1,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
    },
    title: {
      fontSize: '18px',
      fontWeight: '700',
      color: colors.color22,
      wordBreak: 'break-word',
    },
    mainGrid: {
      flex: 1,
      minHeight: 0,
      alignItems: 'stretch',
    },
    rightPanel: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      padding: '0 8px',
    },
  }
}
